import { Marker, Popup } from 'react-leaflet'
import { PointResponse } from '../../../../constants/types'
import { PopupText } from '../PopupText/PopupText'
import { useAppSelector } from '../../../../hooks/redux/redux'
import { getMarkerIcon } from '../../../../utils/markers/getMarkerIcon'
import { useSideBarControlls } from '../../../../hooks/useSideBarControlls'
import { addEllipsisEnding } from '../../../../utils/strings/addEllipsisEnding'
import { useActions } from '../../../../hooks/redux/actions'
import { useEffect, useRef, useState } from 'react'
import { showLeavePointCreationModal } from '../../../../utils/modals/showLeavePointCreationModal'
import { useUuiContext, UuiContexts } from '@epam/uui-core'
import './EditableMarkerPlace.scss'

const MAX_NUM_LETTERS_TO_DISPLAY = 60

export const EditableMarkerPlace = (point: PointResponse & { iconId: any }) => {
  const { showPointInfo } = useSideBarControlls()
  const initialPosition = { lat: point.lat, lng: point.lng } as L.LatLng
  const [position, setPosition] = useState(initialPosition)
  const markerRef = useRef(null)
  const { selectedPointId } = useAppSelector((state) => state.points)
  const { isNewPointFormOpened, isEditPointFormOpened } = useAppSelector(
    (state) => state.app
  )

  const { setEditPointPosition } = useActions()
  const svc = useUuiContext<UuiContexts>()
  const isPointSelected = selectedPointId === point.id

  useEffect(() => {
    if (isEditPointFormOpened && isPointSelected) {
      setEditPointPosition(position)
    }
  }, [
    position,
    isEditPointFormOpened,
    // setEditPointPosition
  ])

  useEffect(() => {
    setPosition(initialPosition)
  }, [isPointSelected, isEditPointFormOpened])

  return (
    <Marker
      draggable={isEditPointFormOpened && selectedPointId === point.id}
      icon={getMarkerIcon(selectedPointId === point.id, point.iconId)}
      ref={markerRef}
      position={position}
      eventHandlers={{
        click: () => {
          if (!isPointSelected) {
            if (isNewPointFormOpened || isEditPointFormOpened) {
              showLeavePointCreationModal(svc).then(
                () => {
                  showPointInfo(point)
                },
                () => {}
              )
            } else {
              showPointInfo(point)
            }
          }
        },
        mouseover: (event) => event.target.openPopup(),
        mouseout: (event) => event.target.closePopup(),
        dragend: (event) => {
          const marker = event.target
          if (marker != null) {
            setPosition({
              lat: marker._latlng.lat,
              lng: marker._latlng.lng,
            } as L.LatLng)
          }
        },
      }}
      opacity={selectedPointId && selectedPointId !== point.id ? 0.5 : 1}
    >
      <Popup closeButton={false}>
        <PopupText>
          {addEllipsisEnding(point.name, MAX_NUM_LETTERS_TO_DISPLAY)}
        </PopupText>
      </Popup>
    </Marker>
  )
}
